import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { DestinationsGrid } from './components/DestinationsGrid';
import { AffiliatesSection } from './components/AffiliatesSection';
import { RequestDestination } from './components/RequestDestination';
import { Footer } from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <DestinationsGrid />
        <AffiliatesSection />
        <RequestDestination />
      </main>
      <Footer />
    </div>
  );
}

export default App;
